import React, { useContext, useEffect, useState } from "react";
import { Redirect, Route, useHistory, withRouter } from "react-router-dom";
import { Avatar, Dropdown, Menu, message, Typography } from "antd";
import PropTypes from "prop-types";

import BaseLayout from "../layout/baseLayout/baseLayout";
import MenuLayout from "../layout/menuLayout/menuLayout";

import { UserOutlined } from "@ant-design/icons";
import { PAGE } from "@utils/constants";

import { getTokenHeader, setTokenHeader } from "../utils/api";
import { me } from "../apis/admin";
import { logout } from "@apis/admin";
import { getAdminSetting } from "../apis/setting";
import { AppContext } from "../App";

AdminRouter.propTypes = {
  component: PropTypes.func,
};
function AdminRouter({ component: Component, ...rest }) {
  let history = useHistory();
  const { Text, Title } = Typography;
  const [user, setUser] = useState({});

  const { adminSetting, setAdminSetting, setLoading } = useContext(AppContext);

  useEffect(() => {
    getMe();
    getSetting();
    // eslint-disable-next-line react-hooks/exhaustive-deps,
  }, []);

  function isLogin() {
    const { adminToken } = getTokenHeader();
    return adminToken;
  }

  const getMe = async () => {
    try {
      const res = await me();
      if (res.error) {
        throw new Error(`${res.error.msgCode} - ${res.error.message}`);
      } else {
        if (res.user.msgCode === 100) {
          message.error("登入逾時，請重新登入", 2, () =>
            history.replace(PAGE.ADMIN_LOGIN)
          );
        } else {
          setUser({
            display: res.user.displayName,
            username: res.user.username,
            profilePic: res.user.profilePic,
            organizationName: res.organization.name,
          });
        }
      }
    } catch (e) {
      // console.log(e)
    }
  };

  const getSetting = async () => {
    setLoading(true);
    try {
      const res = await getAdminSetting();
      if (res.error) {
        throw new Error(`${res.error.msgCode} - ${res.error.message}`);
      } else {
        const { enabledPaymentMethod, ...data } = res;
        setAdminSetting({
          ...adminSetting,
          ...data,
          enabledPaymentMethod: [
            ...adminSetting.enabledPaymentMethod,
            ...enabledPaymentMethod,
          ],
        });
      }
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  const onLogout = async () => {
    try {
      const res = await logout();
      if (res && res.error) {
        throw new Error(`${res.error.msgCode} - ${res.error.message}`);
      } else {
        const { userToken } = getTokenHeader();
        setTokenHeader("", userToken);
        history.push(PAGE.ADMIN_LOGIN);
      }
    } catch (e) {
      // console.log(e)
    }
  };

  const menu = {
    activate: "/admin/program/list",
    menuItems: [
      {
        key: "/admin/program/list",
        title: "課程",
      },
    ],
  };

  const profileAction = (
    <Menu>
      <Menu.Item key="0">
        <Text>{user.display}</Text>
      </Menu.Item>
      <Menu.Divider />
      <Menu.Item key="1">
        <a className="logout-btn" onClick={onLogout}>
          登出
        </a>
      </Menu.Item>
    </Menu>
  );

  const actionBar = () => {
    return (
      <div className="action-bar">
        {isLogin() && (
          <Dropdown overlay={profileAction} trigger={["click"]}>
            <Avatar
              src={user.profilePic ? user.profilePic : ""}
              icon={<UserOutlined />}
            />
          </Dropdown>
        )}
      </div>
    );
  };

  return (
    <BaseLayout
      logoSection={
        <Title className="logo-text" level={4}>
          <a onClick={() => history.push(PAGE.ADMIN_PROGRAM_LIST)}>
            {user.organizationName}
          </a>
        </Title>
      }
      actionBar={actionBar()}
    >
      <MenuLayout menu={menu}>
        <Route
          {...rest}
          render={(props) =>
            isLogin() ? (
              <Component {...props} />
            ) : (
              <Redirect to={PAGE.ADMIN_LOGIN} />
            )
          }
        />
      </MenuLayout>
    </BaseLayout>
  );
}

export default withRouter(AdminRouter);
